/** @jsxImportSource @emotion/react */

import React, { useState } from 'react';
import { connect } from 'unistore/react';
import { css } from '@emotion/react';

import AlertsRow from './alerts-row';
import { bubbleStyle, headingStyle } from '../../common';

import ErrorBoundary from '../../../../components/ErrorBoundary';
import { Button } from '@components';
import IfElse from '../../../../components/IfElse';

import { sidebarActions } from '@utils/store/actions';

const MarginActions = ({
	marginOnGoing,
	marginInFreeze,
	marginInDepo,
	marginAboutToExpire,
	marginExpired,
	__closeSideNotifs,
	innerRef,
	selectedCountry,
}) => {
	const [show, setShow] = useState(true);
	const count =
		marginAboutToExpire.length +
		marginExpired.length +
		(marginInDepo ? 1 : 0) +
		(marginInFreeze ? 1 : 0);
	return (
		count > 0 && (
			<React.Fragment>
				<div
					className="border-b border-gray-400 border-t border-separatorColor flex items-center justify-between p-4 cursor-pointer overflow-hidden"
					css={headingStyle}
					onClick={() => setShow(!show)}
				>
					<div className="font-bold text-primary uppercase">
						Margin Trades:
						<div css={bubbleStyle}>{count}</div>
					</div>

					<Button
						variant="minimal"
						className="p-2 text-base"
						size="tiny"
						css={css`
							margin: -6px 0;
							height: 24px;
							line-height: 0.8;
							width: 30px;
						`}
					>
						{show ? '—' : <span className="text-lg">+</span>}
					</Button>
				</div>
				{show && (
					<ul
						className="mt-0 p-0 bb-notifList"
						ref={innerRef}
						css={css`
							flex: 1;
						`}
					>
						<IfElse
							condition={marginInDepo || marginInFreeze}
							then={
								<AlertsRow
									close={__closeSideNotifs}
									{...marginOnGoing[0]}
									type={
										(marginInDepo && 'd') ||
										(marginInFreeze && 'f')
									}
									country={selectedCountry}
								/>
							}
							else={
								<>
									{marginAboutToExpire.map(
										(actions, index) => {
											const { expiry, coinName } =
												actions;

											return (
												<ErrorBoundary
													key={expiry + coinName}
												>
													<AlertsRow
														close={
															__closeSideNotifs
														}
														index={index}
														type="a"
														{...actions}
														country={
															selectedCountry
														}
													/>
												</ErrorBoundary>
											);
										}
									)}
									{marginExpired.map((actions, index) => {
										const { expiry, coinName } = actions;

										return (
											<ErrorBoundary
												key={expiry + coinName}
											>
												<AlertsRow
													close={__closeSideNotifs}
													index={index}
													type="e"
													country={selectedCountry}
													{...actions}
												/>
											</ErrorBoundary>
										);
									})}
									{/* {marginOnGoing.map((actions, index) => {
										const { expiry, coinName } = actions;

										return (
											<ErrorBoundary
												key={expiry + coinName}
											>
												<AlertsRow
													close={__closeSideNotifs}
													index={index}
													type="s"
													{...actions}
												/>
											</ErrorBoundary>
										);
									})} */}
								</>
							}
						/>
					</ul>
				)}
			</React.Fragment>
		)
	);
};

export default connect(
	`marginReadNotSeen,
	marginOnGoing,
	marginInFreeze,
	marginInDepo,
	marginAboutToExpire,
	marginExpired,
	selectedCountry,
`,
	sidebarActions
)(MarginActions);
